module.exports = __webpack_public_path__ + "img/ae5d293.jpg";